import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { AccountContext } from '../../context';
import { useTranslation } from 'react-i18next';
import Footer from '../Footer';
import { ACCOUNT_LANGUAGES_LIST } from '../../helpers/languages';
import { useIblTranslation } from '../../../../i18n';
import { handleConvertHTMLBreaksToLineBreaks, handleConvertLineBreaksToHTML } from '../../helpers/utils';
import { AppDataContext } from '../../../../utils';

const Basic = () => {

  const DEFAULT_LANG = 'en';
  const { tenantMetaData } = useContext(AppDataContext);
  const {
    userData,
    onUserDataChange,
    userMetaData,
    onUserMetaDataChange,
    METADATANAMES,
    handleSubmit,
    isSubmitting,
  } = useContext(AccountContext);
  const aboutTextareaRef = useRef(null);

  function adjustHeight() {
    aboutTextareaRef.current.style.height = 'inherit';
    aboutTextareaRef.current.style.height = `${aboutTextareaRef.current.scrollHeight}px`;
  }
  const [inputWarning, setInputWarning] = useState('');
  const [titleWarning, setTitleWarning] = useState('');
  
  const MAX_LENGTHS = {
    name: 30,
    bio: 30,
  };
  
  const WARNING_MESSAGES = {
    name: 'Name cannot exceed 30 characters.',
    bio: 'Title cannot exceed 30 characters.',
  };
  useLayoutEffect(adjustHeight, []);

  const { t } = useTranslation('library');
  const { languages } = useIblTranslation();

  const handleUserDisplayToggleChange = (e) => {
    onUserMetaDataChange({
      ...userMetaData,
      public_metadata:{
        ...userMetaData?.public_metadata,
        [e?.target?.name]: e?.target?.value,
      }
    })
  }
  
  const handleKeyDown = (e, field) => {
    const value = userMetaData?.[field] || '';
    const isTypingKey = e.key.length === 1 || e.key === ' ';
  
    const isBlocked =
      value.length >= MAX_LENGTHS[field] &&
      isTypingKey &&
      !e.ctrlKey &&
      !e.metaKey;
  
    if (isBlocked) {
      field === 'name' ? setInputWarning(WARNING_MESSAGES.name) : setTitleWarning(WARNING_MESSAGES.bio);
    }
  };
  
  const handleBlur = (e) => {
    const { name, value } = e.target;
  
    const warning = value.length > MAX_LENGTHS[name] ? WARNING_MESSAGES[name] : '';
    if (name === 'name') setInputWarning(warning);
    if (name === 'bio') setTitleWarning(warning);
  };
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    // Clear warnings if back below limit
    if (value.length < MAX_LENGTHS[name]) {
      if (name === 'name') setInputWarning('');
      if (name === 'bio') setTitleWarning('');
    }

    if (METADATANAMES.includes(e?.target?.name)) {
      onUserMetaDataChange({
        ...userMetaData,
        ...(e?.target?.name === 'about' ?
          {
            [e?.target?.name]: handleConvertLineBreaksToHTML(e?.target?.value),
          }
          : {
            [e?.target?.name]: e?.target?.value,
          }),

      });
    } else {
      onUserDataChange({
        ...userData,
        [e?.target?.name]: e?.target?.value,
      });
    }
  };


  return (
    <div data-name={'basic'} className="manage-account-form-block w-form">
      <form
        onSubmit={handleSubmit}
        id="email-form-2"
        name="email-form-2"
        data-name={'Email Form 2'}
        method="get"
        className="manage-account-form"
        data-wf-page-id="65aec9c9e13ed74d8bfffe77"
        data-wf-element-id="f097fb24-dc47-4961-e662-a4078f3e5401"
      >
        <div className="w-layout-hflex-account-ui tabs-content basic-information-block">
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Full Name')}
              </label>
              <label htmlFor="name" className="form-input-label required">
                *
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Your full name')}</div>
            <input
              className="form-input w-input"
              maxLength={30}
              name="name"
              value={userMetaData?.name || ''}
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="text"
              id="organisation-name-3"
              onKeyDown={(e)=>handleKeyDown(e, 'name')}
              onBlur={handleBlur} 
            />
              {inputWarning && (
              <p style={{ color: 'red', fontSize: '0.875rem' }}>{inputWarning}</p>
            )}
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Email')}
              </label>
            </div>
            <div className="form-input-desc hidden">
              {t('A confirmation link would be sent to you immediately')}
            </div>
            <input
              className="form-input w-input"
              maxLength={256}
              value={userMetaData?.email || ''}
              name="email"
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="email"
              id="organisation-name-3"
            />
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Username')}
              </label>
            </div>
            <div className="form-input-desc hidden">
              {t('A confirmation link would be sent to you immediately')}
            </div>
            <input
              className="form-input disabled w-input"
              maxLength={256}
              disabled={true}
              readOnly={true}
              name="user_nicename"
              value={userData?.user_nicename || ''}
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="text"
              id="organisation-name-3"
            />
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Title')}
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Must be unique')}</div>
            <input
              className="form-input w-input"
              maxLength={30}
              name="bio"
              value={userMetaData?.bio || ''}
              onChange={handleInputChange}
              data-name={'Organisation Name 3'}
              placeholder=""
              custom-value="Personal"
              type="text"
              id="organisation-name-3"
              onKeyDown={(e)=>handleKeyDown(e, 'bio')}
              onBlur={handleBlur} 
            />
              {titleWarning && (
              <p style={{ color: 'red', fontSize: '0.875rem' }}>{titleWarning}</p>
            )}
            <div className="text-error hidden">{'Minimum 8 characters'}</div>
          </div>
          <div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('About')}
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Must be unique')}</div>
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
            <textarea
              ref={aboutTextareaRef}
              name="about"
              value={handleConvertHTMLBreaksToLineBreaks(String(userMetaData?.about)) || ''}
              onChange={handleInputChange}
              placeholder=""
              maxLength={5000}
              id="field"
              data-name={'Field'}
              className="textarea w-input about-textarea"
            ></textarea>
          </div>
          <div className="w-layout-vflex account-input-block">
            <div className="w-layout-hflex label-block"><label htmlFor="name-6"
                                                               className="form-input-label">Language</label></div>
            <select id="field-2" name="language" data-name="Field 2"
                    className="select-field w-select account-language-dropdown" onChange={handleInputChange}>
              {
                Object.entries(languages).map(([key, value]) => (
                  <option selected={key === (userMetaData?.language ?? DEFAULT_LANG)}
                          value={key}>{value}</option>
                ))
              }
            </select>
          </div>
          {
            process.env.REACT_APP_ENABLE_SKILL_LEADERBOARD === 'true' && (
               <div className={'w-layout-hflex-account-ui checkbox-input-field-block'}>
            {
              tenantMetaData?.enable_public_profile_toggle_display && (
                <div className="w-layout-vflex-account-ui account-input-block">
                  <div className="w-layout-hflex-account-ui label-block">
                    <label htmlFor="name" className="form-input-label">
                      {t('Public Profile')}
                    </label>
                  </div>
                  <div className="form-input-desc hidden">{t('Must be unique')}</div>
                  <div className="text-error hidden">{t('Minimum 8 characters')}</div>
                  <label className="w-checkbox">
                    <input
                      type="checkbox"
                      id="checkbox"
                      checked={!!userMetaData?.is_profile_public}
                      name="is_profile_public"
                      onChange={(e) =>
                        handleInputChange({
                          target: {
                            name: 'is_profile_public',
                            value: !userMetaData?.is_profile_public,
                          },
                        })
                      }
                      data-name={'Checkbox'}
                      className="w-checkbox-input"
                    />
                    <label className="w-form-label" htmlFor="checkbox">
                      {t('Make Profile Public')}
                    </label>
                  </label>
                </div>
              )
            }
            <div className="w-layout-vflex-account-ui account-input-block">
              <div className="w-layout-hflex-account-ui label-block">
                <label htmlFor="name" className="form-input-label">
                  {t('Mentor AI')}
                </label>
              </div>
              <label className="w-checkbox">
                <input
                  type="checkbox"
                  id="enable_sidebar_ai_mentor_display_checkbox"
                  checked={userMetaData?.public_metadata?.enable_sidebar_ai_mentor_display!==false}
                  name="enable_sidebar_ai_mentor_display"
                  onChange={(e) =>
                    handleUserDisplayToggleChange({
                      target: {
                        name: 'enable_sidebar_ai_mentor_display',
                        value: userMetaData?.public_metadata?.enable_sidebar_ai_mentor_display===false,
                      },
                    })
                  }
                  data-name={'Checkbox'}
                  className="w-checkbox-input"
                />
                <label className="w-form-label" htmlFor="enable_sidebar_ai_mentor_display_checkbox">
                  {t('Display Mentor AI')}
                </label>
              </label>
            </div>
            <div className="w-layout-vflex-account-ui account-input-block">
              <div className="w-layout-hflex-account-ui label-block">
                <label htmlFor="name" className="form-input-label">
                  {t("Skill's Leaderboard")}
                </label>
              </div>
              <label className="w-checkbox">
                <input
                  type="checkbox"
                  id="enable_skills_leaderboard_display_checkbox"
                  checked={userMetaData?.public_metadata?.enable_skills_leaderboard_display!==false}
                  name="enable_skills_leaderboard_display"
                  onChange={(e) =>
                    handleUserDisplayToggleChange({
                      target: {
                        name: 'enable_skills_leaderboard_display',
                        value: userMetaData?.public_metadata?.enable_skills_leaderboard_display===false,
                      },
                    })
                  }
                  data-name={'Checkbox'}
                  className="w-checkbox-input"
                />
                <label className="w-form-label" htmlFor="enable_skills_leaderboard_display_checkbox">
                  {t('Display Leaderboard')}
                </label>
              </label>
            </div>
          </div>
            )
          }
          {/*<div className="w-layout-vflex-account-ui account-input-block">
            <div className="w-layout-hflex-account-ui label-block">
              <label htmlFor="name" className="form-input-label">
                {t('Public Profile')}
              </label>
            </div>
            <div className="form-input-desc hidden">{t('Must be unique')}</div>
            <div className="text-error hidden">{t('Minimum 8 characters')}</div>
            <label className="w-checkbox">
              <input
                type="checkbox"
                id="checkbox"
                checked={!!userMetaData?.is_profile_public}
                name="is_profile_public"
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: 'is_profile_public',
                      value: !userMetaData?.is_profile_public,
                    },
                  })
                }
                data-name={'Checkbox'}
                className="w-checkbox-input"
              />
              <label className="w-form-label" htmlFor="checkbox">
                {t('Make Profile Public')}
              </label>
            </label>
          </div>*/}
        </div>
        <Footer isSubmitting={isSubmitting} handleSubmit={handleSubmit} />
      </form>
      <div className="w-form-done">
        <div>{t('Thank you! Your submission has been received!')}</div>
      </div>
      <div className="w-form-fail">
        <div>{t('Oops! Something went wrong while submitting the form.')}</div>
      </div>
    </div>
  );
};

export default Basic;
